<template>
    <div id="orthoTreatmentDiv" class="ortho-treatment-item ortho-controls">

        <div id="orthoTreatmentOriginalDiv" class="ortho-treatment-item toggle-div"
            v-on:click.stop="switchShowOriginalClick($event)">
            <input id="orthoTreatmentOriginalButton" type="checkbox" class="toggle-ortho-treatment-button" />
            <div id="orthoTreatmentOriginalLabel" class="toggle-title"
                v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">SHOW ORIGINAL</div>
        </div>

        <button v-show="treatmentContext.showOriginal" type="button" class="original-button"
            onclick="openColorPicker('original_teeth_color');">
            TEETH COLOR
        </button>

        <div id="orthoTreatmentCollisionsDiv" class="ortho-treatment-item toggle-div"
            v-on:click.stop="switchShowCollisionsClick($event)">
            <input id="orthoTreatmentCollisionsButton" type="checkbox" class="toggle-ortho-treatment-button" />
            <div id="orthoTreatmentCollisionsLabel" class="toggle-title"
                v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">SHOW ROOT COLLISIONS</div>
        </div>

        <div id="orthoTreatmentClosedBonesDiv" class="ortho-treatment-item toggle-div"
            v-on:click.stop="switchClosedBonesClick($event)">
            <input id="orthoTreatmentClosedBonesButton" type="checkbox" class="toggle-ortho-treatment-button" />
            <div id="orthoTreatmentClosedBonesLabel" class="toggle-title"
                v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">SHOW CLOSED BONES</div>
        </div>

        <div id="orthoShowUnknownRootsDiv" class="ortho-treatment-item toggle-div"
            v-on:click.stop="switchShowUnknownRootsClick($event)">
            <input id="orthoShowUnknownRootsButton" type="checkbox" class="toggle-ortho-treatment-button" />
            <div id="orthoShowUnknownRootsLabel" class="toggle-title"
                v-bind:style="{ color: mode.isWhite ? mode.blueColor : mode.whiteColor }">SHOW UNKNOWN ROOTS</div>
        </div>
    </div>
</template>

<script>

import {
    switchTreatmentShowOriginal,
    switchTreatmentClosedBones,
    switchTreatmentShowCollisions,
    switchTreatmentAnchorageLoss,
    switchShowUnknownRoots
} from "./OrthoTreatment.js";

export default {
    name: "OrthoTreatmentControls",
    props: ["mode", "isIntraoral", "treatmentContext"],
    methods: {
        switchShowOriginalClick: function () {
            switchTreatmentShowOriginal(!this.treatmentContext.showOriginal);
        },
        switchShowCollisionsClick: function () {
            switchTreatmentShowCollisions(!this.treatmentContext.showRootCollisions);
        },
        switchClosedBonesClick: function () {
            switchTreatmentClosedBones();
        },
        showAnchorageLossClick: function () {
            switchTreatmentAnchorageLoss(!this.treatmentContext.showAnchorageLoss);
        },
        switchShowUnknownRootsClick: function () {
            switchShowUnknownRoots(!this.treatmentContext.showUnknownRoots);
        }
    },
    mounted: function () {
        canecode_switch(".toggle-ortho-treatment-button");
        switchToggle('orthoTreatmentClosedBonesDiv', this.treatmentContext.showAllStages);
        switchToggle('orthoTreatmentOriginalDiv', this.treatmentContext.showOriginal);
        switchToggle('orthoTreatmentCollisionsDiv', this.treatmentContext.showRootCollisions);
        switchToggle('orthoShowUnknownRootsDiv', false);

        if (!vueApp.hasClosedBones) {
            // document.getElementById("orthoTreatmentAnchorageLossDiv").style.display = "none";
            document.getElementById("orthoTreatmentClosedBonesDiv").style.display = "none"
        }
    }
};
</script>

<style scoped>
.ortho-treatment-item {
    position: absolute;
}

#orthoTreatmentDiv {
    left: calc(50% - 220px);
    top: 50px;
    width: 440px;
    color: white;
    display: none;
}

#orthoTreatmentOriginalDiv {
    left: calc(50% - 245px);
    /* top: 75px; */
}

#orthoTreatmentOriginalLabel {
    margin-left: -17px;
}

#orthoTreatmentCollisionsDiv {
    left: calc(50% - 85px);
}

#orthoTreatmentCollisionsLabel {
    margin-left: -45px;
}

#orthoTreatmentClosedBonesDiv {
    left: calc(50% + 90px);
}

#orthoTreatmentClosedBonesLabel {
    margin-left: -35px;
}

#orthoShowUnknownRootsDiv {
    left: calc(50% - 85px);
    top: 85px;
}

#orthoShowUnknownRootsLabel {
    margin-left: -46px;
}

.original-button {
    position: absolute;
    width: 110px;
    height: 40px;
    border: 0;
    cursor: pointer;
    font-size: 12px;
    background-color: #4687fc;
    z-index: 9;
    top: 84px;
    color: white;
    left: calc(50% - 259px);
}
</style>